import {
  FulfillmentTypeDeleteAndReassignRequestType,
  FulfillmentTypeDeleteAndReassignResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useFulfillmentTypeDeleteAndReassign = (
  fulfillmentTypeId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: FulfillmentTypeDeleteAndReassignRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `fulfillment-type/${fulfillmentTypeId}/delete-and-reassign`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as FulfillmentTypeDeleteAndReassignResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.FulfillmentType,
          fulfillmentTypeId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
